module.exports = __webpack_public_path__ + "static/media/FooterLogo.52c59faa.svg";